import type { CountryLanguages } from '~/types/countryLanguages';
import type { SectionId } from '~/types/sectionId';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { findSectionConfigForPath } from '~/utils/findSectionConfigForPath';

const RESTRICTED_SECTION_IDS = new Set<SectionId>(['fachportal', 'pta-family']);

export function isRestrictedSectionPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    path: string,
    countryLanguages: CountryLanguages
): boolean {
    const config = findSectionConfigForPath(registry, path, countryLanguages);
    return Boolean(config && RESTRICTED_SECTION_IDS.has(config.sectionId));
}
